import { ENTITY_TYPES } from '@sales-center/common'
import {
  selectAllAgreementForms,
  useGetFormsOnMount,
} from '@user/store/agreements'
import { useAppSelector } from '@user/store/hooks'
import { useMemo } from 'react'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityId, entityType } = props

  const status = useGetFormsOnMount({
    externalEntityType: entityType.toString(),
    externalEntityId: entityId.toString(),
  })

  const agreements = useAppSelector(selectAllAgreementForms)

  const loading = status === 'pending'

  const sortedAgreements = useMemo(
    () =>
      agreements.map((row) => {
        const sortedHistory = [...row?.history]?.sort(
          (a, b) =>
            new Date(b?.modifiedDate)?.getTime() -
            new Date(a?.modifiedDate)?.getTime(),
        )

        return {
          ...row,
          history: sortedHistory,
        }
      }),
    [agreements],
  )

  return {
    agreements: sortedAgreements,
    loading,
  }
}
